import { authClient, API } from "../index";

// Count all leats
export const countLeats = () => {
  return authClient().get(`${API}/leat/count`);
};

// Get all leats
export const getLeats = () => {
  return authClient().get(`${API}/leat`);
};

// Get leat by id
export const getLeatById = (id) => {
  return authClient().get(`${API}/leat/${id}`);
};

// Update leat
export const updateLeat = (id, leat) => {
  return authClient().put(`${API}/leat/${id}`, leat);
};

// Create leat
export const postLeat = (leat) => {
  return authClient().post(`${API}/leat`, leat);
};

// Delete leat
export const deleteLeat = (id) => {
  return authClient().delete(`${API}/leat/${id}`);
};

// Count unread leats
export const countUnreadLeats = () => {
  return authClient().get(`${API}/leat/count-unread`);
};

export const markLeatsAsRead = () => {
  return authClient().patch(`${API}/leat/mark-all-read`);
};